/**
 * Swiper Initializations
 * Generic swiper initializer with config array
 */

// Swiper configurations array - add new swipers here
var swiperConfigs = [
    {
        selector: '.heroSwiper',
        options: {
            a11y: { enabled: false },
            slidesPerView: 'auto',
            spaceBetween: 50,
            loop: true,
            autoplay: { 
                delay: 0, 
                disableOnInteraction: false,
                pauseOnMouseEnter: false  // Add this
            },
            speed: 8000,  // Increase this for smoother motion (was 3000)
            freeMode: true,  // Add this for continuous motion
            freeModeMomentum: false,  // Add this to prevent deceleration
            allowTouchMove: true,
            breakpoints: {
                1280: { slidesPerView: 5, spaceBetween: 80 },
                1024: { slidesPerView: 4, spaceBetween: 60 },
                768: { slidesPerView: 3, spaceBetween: 40 },
                390: { slidesPerView: 3, spaceBetween: 30 },
                320: { slidesPerView: 2.5, spaceBetween: 40 }
            }
        }
    },
    {
        selector: '.trusted-by-swiper-upper',
        options: {
            a11y: { enabled: false },
            slidesPerView: 5,
            spaceBetween: 130,
            loop: true,
            autoplay: { delay: 2000, disableOnInteraction: false, reverseDirection: true },
            speed: 600,
            allowTouchMove: true,
            breakpoints: {
                1280: { slidesPerView: 5, spaceBetween: 60 },
                1024: { slidesPerView: 4, spaceBetween: 40 },
                768: { slidesPerView: 3, spaceBetween: 30 },
                390: { slidesPerView: 3, spaceBetween: 25 },
                320: { slidesPerView: 2, spaceBetween: 20 }
            }
        }
    },
    {
        selector: '.trusted-by-swiper-lower',
        options: {
            a11y: { enabled: false },
            slidesPerView: 4,
            spaceBetween: 153,
            loop: true,
            autoplay: { delay: 2000, disableOnInteraction: false },
            speed: 600,
            breakpoints: {
                1280: { slidesPerView: 4, spaceBetween: 60 },
                1024: { slidesPerView: 4, spaceBetween: 40 },
                768: { slidesPerView: 3, spaceBetween: 30 },
                390: { slidesPerView: 3, spaceBetween: 25 },
                320: { slidesPerView: 2, spaceBetween: 20 }
            }
        }
    },
    {
        selector: '.trusted-by-swiper',
        multiple: true,
        options: {
            a11y: { enabled: false },
            slidesPerView: 'auto',
            spaceBetween: 50,
            loop: true,
            autoplay: { delay: 0, disableOnInteraction: false },
            speed: 3000,
            allowTouchMove: true,
            breakpoints: {
                0: { slidesPerView: 2, spaceBetween: 30 },
                640: { slidesPerView: 3, spaceBetween: 40 },
                768: { slidesPerView: 3, spaceBetween: 40 },
                1024: { slidesPerView: 4, spaceBetween: 40 },
                1280: { slidesPerView: 6, spaceBetween: 56 }
            }
        }
    },
    {
        selector: '.our-project-portfolio-swiper',
        options: {
            a11y: { enabled: false },
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true,
            autoHeight: false,
            autoplay: { delay: 4000, disableOnInteraction: false },
            speed: 800,
            breakpoints: {
                520: { slidesPerView: 1.2, spaceBetween: 16 },
                768: { slidesPerView: 1.5, spaceBetween: 20 },
                1024: { slidesPerView: 2.1, spaceBetween: 24 },
                1280: { slidesPerView: 2.5, spaceBetween: 30 }
            }
        }
    },
    {
        selector: '.blog-posts-swiper',
        options: {
            a11y: { enabled: false },
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,
            autoplay: { delay: 4000, disableOnInteraction: false },
            speed: 800,
            navigation: { nextEl: '.blog-posts-next', prevEl: '.blog-posts-prev' },
            pagination: {
                el: '.blog-posts-pagination',
                clickable: true,
                renderBullet: function(index, className) {
                    return '<span class="' + className + ' w-2 h-2 rounded-full bg-gray-300 cursor-pointer transition-colors duration-300"></span>';
                }
            },
            breakpoints: {
                320: { slidesPerView: 1, spaceBetween: 24 },
                576: { slidesPerView: 1.5, spaceBetween: 24 },
                768: { slidesPerView: 2, spaceBetween: 24 },
                1024: { slidesPerView: 2.5, spaceBetween: 25 },
                1440: { slidesPerView: 3, spaceBetween: 30 },
                1580: { slidesPerView: 3.5, spaceBetween: 30 }
            }
        }
    },
    {
        selector: '.badges-section-swiper',
        options: {
            a11y: { enabled: false },
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true,
            autoHeight: false,
            autoplay: { delay: 4000, disableOnInteraction: false, pauseOnMouseEnter: true },
            speed: 800,
            grabCursor: true,
            allowTouchMove: true,
            touchEventsTarget: 'container',
            observer: true,
            observeParents: true,
            resizeObserver: true,
            breakpoints: {
                475: { slidesPerView: 1.2, spaceBetween: 20 },
                768: { slidesPerView: 2, spaceBetween: 24 },
                1024: { slidesPerView: 2.3, spaceBetween: 24 },
                1280: { slidesPerView: 3, spaceBetween: 30 },
                1440: { slidesPerView: 3.5, spaceBetween: 30 }
            }
        }
    },
    {
        selector: '.why-choose-vt-swiper',
        options: {
            a11y: { enabled: false },
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,
            autoHeight: false,
            autoplay: { delay: 4000, disableOnInteraction: false },
            speed: 800,
            breakpoints: {
                0: { enabled: false, spaceBetween: 0 },
                640: { slidesPerView: 1.5, spaceBetween: 20 },
                768: { slidesPerView: 1.5, spaceBetween: 24 },
                1024: { slidesPerView: 2.2, spaceBetween: 24 },
                1440: { slidesPerView: 3, spaceBetween: 30 },
                1580: { slidesPerView: 3.5, spaceBetween: 30 }
            }
        }
    },
    {
        selector: '.project-images-swiper',
        options: {
            a11y: { enabled: false },
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,
            autoHeight: false,
            autoplay: { delay: 4000, disableOnInteraction: false },
            speed: 800,
            breakpoints: {
                320: { slidesPerView: 1, spaceBetween: 20 },
                475: { slidesPerView: 1.2, spaceBetween: 20 },
                768: { slidesPerView: 1.5, spaceBetween: 24 },
                1024: { slidesPerView: 1.6, spaceBetween: 24 },
                1440: { slidesPerView: 1.4, spaceBetween: 30 }
            }
        }
    },
    {
        selector: '.latest-blogs-swiper',
        options: {
            slidesPerView: 1,
            spaceBetween: 16,
            grabCursor: true,
            loop: true,
            autoHeight: false,
            autoplay: { delay: 4000, disableOnInteraction: false },
            speed: 800,
            breakpoints: {
                475: { slidesPerView: 1.5, spaceBetween: 20 },
                640: { slidesPerView: 2, spaceBetween: 20 },
                1024: { slidesPerView: 2.3, spaceBetween: 30 },
                1280: { slidesPerView: 3, spaceBetween: 30, allowTouchMove: false }
            }
        }
    },
    {
        selector: '.related-blogs-swiper',
        options: {
            a11y: { enabled: false },
            slidesPerView: 1,
            spaceBetween: 20,
            loop: false,
            autoplay: false,
            breakpoints: {
                768: { slidesPerView: 2, spaceBetween: 25 },
                1024: { slidesPerView: 3, spaceBetween: 30 }
            }
        }
    },
    {
        selector: '.hover-cards-mobile-swiper, .hover-cards-service-swiper',
        multiple: true,
        scopedNavigation: true, // Use parent-scoped navigation/pagination
        options: {
            a11y: { enabled: false },
            slidesPerView: 1.1,
            spaceBetween: 16,
            loop: true,
            autoplay: { delay: 4000, disableOnInteraction: false },
            speed: 800,
            breakpoints: {
                576: { slidesPerView: 1.3, spaceBetween: 20 },
                768: { slidesPerView: 1.7, spaceBetween: 25 },
                1024: { slidesPerView: 2.2, spaceBetween: 30 },
                1200: { slidesPerView: 2.6, spaceBetween: 30 }
            }
        }
    }
];

var swiperInstances = [];
var resizeHandlerBound = false;

function createSwiper(element, options) {
    if (!element || element.swiper) {
        return element ? element.swiper : null;
    }

    var instance = new Swiper(element, options);
    swiperInstances.push(instance);
    return instance;
}

function bindSwiperResizeHandler() {
    if (resizeHandlerBound) {
        return;
    }

    resizeHandlerBound = true;
    var resizeTimer;

    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            swiperInstances.forEach(function(swiper) {
                if (swiper && !swiper.destroyed) {
                    swiper.update();
                }
            });
        }, 150);
    });
}

// Generic swiper initializer function
export function initSwipers() {
    if (typeof Swiper === 'undefined') {
        setTimeout(initSwipers, 100);
        return;
    }

    bindSwiperResizeHandler();

    swiperConfigs.forEach(function(config) {
        if (config.multiple) {
            var elements = document.querySelectorAll(config.selector);
            elements.forEach(function(el) {
                if (!el.swiper) {
                    var options = getAdjustedOptions(el, config.options);
                    
                    // Handle scoped navigation/pagination (find elements within parent container)
                    if (config.scopedNavigation) {
                        var parent = el.parentElement;
                        var pagination = parent.querySelector('.swiper-pagination, [class*="-pagination"]');
                        var prevBtn = parent.querySelector('[class*="-prev"]');
                        var nextBtn = parent.querySelector('[class*="-next"]');
                        
                        if (pagination) {
                            options.pagination = { el: pagination, clickable: true };
                        }
                        if (prevBtn && nextBtn) {
                            options.navigation = { prevEl: prevBtn, nextEl: nextBtn };
                        }
                    }
                    
                    createSwiper(el, options);
                }
            });
        } else {
            var element = document.querySelector(config.selector);
            if (element && !element.swiper) {
                var options = getAdjustedOptions(element, config.options);
                createSwiper(element, options);
            }
        }
    });
}

/**
 * Check if there are enough slides for loop mode
 * If not, disable loop to prevent warnings
 */
function getAdjustedOptions(element, originalOptions) {
    var options = Object.assign({}, originalOptions);
    
    // Count slides
    var slides = element.querySelectorAll('.swiper-slide');
    var slideCount = slides.length;
    
    // Get max slidesPerView from breakpoints or base config
    var maxSlidesPerView = getMaxSlidesPerView(options);
    
    // Loop requires at least slidesPerView + 1 slides
    var minSlidesForLoop = Math.ceil(maxSlidesPerView) + 1;
    
    // Disable loop if not enough slides
    if (options.loop && slideCount < minSlidesForLoop) {
        options.loop = false;
    }
    
    return options;
}

/**
 * Get the maximum slidesPerView from options and breakpoints
 */
function getMaxSlidesPerView(options) {
    var max = 1;
    
    // Check base slidesPerView
    if (options.slidesPerView && options.slidesPerView !== 'auto') {
        max = Math.max(max, options.slidesPerView);
    }
    
    // Check breakpoints
    if (options.breakpoints) {
        Object.keys(options.breakpoints).forEach(function(breakpoint) {
            var bp = options.breakpoints[breakpoint];
            if (bp.slidesPerView && bp.slidesPerView !== 'auto') {
                max = Math.max(max, bp.slidesPerView);
            }
        });
    }
    
    return max;
}

